import Learning from '../../assets/htbd-images/Layer.png';
import check from '../../assets/htbd-images/check.png';

function EvaluationCriteria() {
  return (
      <section
        className="container-fluid p-5 position-relative" style={{ zIndex: '-2', backgroundColor: "#212239" }}
      >
        <div className="row justify-content-md-center text-white">
          <h1 className="text-center">
          Evaluation <strong style={{ color: "#7e56d8" }}>Criteria</strong>
          </h1>
          <div className="col-lg-5">
          <p className='text-center'>
            You will be evaluated on
          </p>
          <div className="p-3" style={{ backgroundColor: "#f39322" }}>
              <p>
                <img src={check} className="me-2" alt="check" height={'15px'} />
                Knowledge of the infrastructure
              </p>
              <p>
                <img src={check} className="me-2" alt="check" height={'15px'} />

                Understanding of Arabic culture
              </p>
              <p>
                <img src={check} className="me-2" alt="check" height={'15px'} />

                Knowledge of city demographics
              </p>
              <p>
                <img src={check} className="me-2" alt="check" height={'15px'} />

                Knowledge of Government resources allocated for ease of business
              </p>
            </div>
          </div>
          <div className="col-lg-5">
          <p className='text-center'>
            The evaluation will be through
          </p>
            <div className="p-3" style={{ backgroundColor: "#f39322" }}>
              <p>
                <img src={check} className="me-2" alt="check" height={'15px'} />

                Quiz on city infrastructure
              </p>
              <p>
                <img src={check} className="me-2" alt="check" height={'15px'} />

                Quiz on Arabic business culture
              </p>
              <p>
                <img src={check} className="me-2" alt="check" height={'15px'} />

                Reflective diaries on city demographics
              </p>
              <p>
                <img src={check} className="me-2" alt="check" height={'15px'} />

                Quiz on Government resources available for ease of business
              </p>
            </div>
          </div>
          <div className='col-lg-5 text-center mt-3'>
            On the LMS system, you will find questions on your left the link to your resources on your right,
            and your answer will go in the middle which is a text editor. The link to the tutorial video will be
            emailed to you on the completion of enrollment formalities.
          </div>
        </div>
      </section>
  );
}

export default EvaluationCriteria;
